import * as React from "react";
import { gql, useMutation, ApolloError } from "@apollo/client";
import {
  DeleteRepContactMutationMutation,
  DeleteRepContactMutationMutationVariables,
} from "../../../../../../schemaTypes";
import { normalizeErrors } from "../../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../../types/NormalizedErrorMap";

export const deleteRepContactMutation = gql`
  mutation DeleteRepContactMutation($id: String!) {
    deleteRepContact(id: $id) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: DeleteRepContactMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const DeleteRepContact: React.FC<Props> = ({ children, onMessage }) => {
  const [_deleteRepContactMutation, { loading, error }] = useMutation<
    DeleteRepContactMutationMutation,
    DeleteRepContactMutationMutationVariables
  >(deleteRepContactMutation);

  const submit = async (
    values: DeleteRepContactMutationMutationVariables
  ) => {
    const { data } = await _deleteRepContactMutation({
      variables: values,
    });

    const errors = data?.deleteRepContact?.errors
      ? normalizeErrors(data.deleteRepContact.errors)
      : null;

    if (data?.deleteRepContact?.message && onMessage) {
      onMessage(data.deleteRepContact.message);
    }

    return {
      errors,
      message: data?.deleteRepContact?.message ?? undefined,
    };
  };

  return children({ submit, loading, error });
};
